import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

export default function Deliveries() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState('');
  async function load() {
    const r = await api.deliveries(status ? { status } : {});
    setItems(r.deliveries);
  }
  useEffect(() => { load().catch(console.error); }, [status]);

  async function advance(d, next) { await api.updateDelivery(d.id, { status: next }); load(); }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Deliveries</h1>
        <select className="input w-44" value={status} onChange={e => setStatus(e.target.value)}>
          <option value="">All statuses</option>
          <option value="pending">Pending</option>
          <option value="in_transit">In transit</option>
          <option value="delivered">Delivered</option>
        </select>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map(d => (
          <div key={d.id} className="card p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-medium">{d.first_name} {d.last_name}</div>
                <div className="text-xs text-slate-500">MRN {d.mrn} · Rm {d.room_number}</div>
              </div>
              <span className={`badge-${d.status === 'delivered' ? 'success' : d.status === 'in_transit' ? 'info' : 'warning'}`}>{d.status}</span>
            </div>
            <div className="mt-3 text-sm">
              <div className="text-slate-600">📍 {d.delivery_location}</div>
              <div className="text-xs text-slate-500 mt-1">
                Scheduled {d.scheduled_at ? new Date(d.scheduled_at).toLocaleTimeString() : '—'}
              </div>
            </div>
            <ul className="mt-3 text-xs space-y-1">
              {(d.prescriptions || []).map(rx => (
                <li key={rx.id}>• {rx.drug_name} <span className="text-slate-500">({rx.status})</span></li>
              ))}
            </ul>
            <div className="flex gap-2 mt-3">
              {d.status === 'pending' && <button onClick={() => advance(d, 'in_transit')} className="btn-primary text-xs">Mark in transit</button>}
              {d.status === 'in_transit' && <button onClick={() => advance(d, 'delivered')} className="btn-primary text-xs">Mark delivered</button>}
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-slate-400 text-sm">No deliveries</div>}
      </div>
    </div>
  );
}
